<script lang="ts" setup>
import type { PanelWithHeaderToggle } from '#layers/workspace/types/panel';
import { computed } from 'vue';
import { usePaneStore } from '#layers/workspace/stores/pane';

const paneStore = usePaneStore();

const panelsWithHeaderToggle = computed(() =>
	paneStore.panels.filter((panel): panel is PanelWithHeaderToggle => panel.showHeaderToggle !== false),
);

function isPanelActive(panelId: string) {
	return paneStore.panelOpen && paneStore.currentPanel?.id === panelId;
}

function togglePanel(panelId: string) {
	paneStore.togglePanel({ panelId });
}
</script>

<template>
	<div class="flex items-center gap-x-1">
		<DTooltip
			v-for="panel in panelsWithHeaderToggle"
			:key="panel.id"
			:text="panel.label"
		>
			<component
				:is="panel.toggleComponent"
				v-if="panel.toggleComponent"
				:active="isPanelActive(panel.id)"
				:aria-label="panel.label"
				@click="togglePanel(panel.id)"
			/>

			<DButton
				v-else
				size="sm"
				variant="ghost"
				color="neutral"
				:icon="panel.icon"
				:pressed="isPanelActive(panel.id)"
				:aria-label="panel.label"
				class="rounded-sm"
				@click="togglePanel(panel.id)"
			/>
		</DTooltip>
	</div>
</template>
